// 页面缓存配置
export const PageCacheConfig = {
  // 当前需要缓存的路由名称：['跳转的路由路径']
  personnelList: ['/personnel/editPersonnel', '/personnel/personnelDetail'],
  resignPersonnel: ['/personnel/resignDetail'],
  talentPool: ['/audition/auditionDetail'],
  auditionList: ['/audition/auditionDetail', '/audition/editAudition'],
  outsourcingList: ['/personnel/editOutsourcing', '/personnel/OutsourcingDetail', '/personnel/transferIn']
}